import React, { Component } from "react";
import axios from 'axios'
import { BASEURL } from "../Config";
import { NavLink } from "react-router-dom";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import swal from 'sweetalert';

class AddBooks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [{
                name: "",
                classno: 0,
                subject: "",
            }],
            subjects: []
        }
    }

    componentDidMount() {
        axios
            .get(`${BASEURL}/api/v1/subjects/fetchall`)
            .then(res => {
                console.log('res.data', res.data);
                let subjects = this.state.subjects;
                for (let i = 0; i < res.data.length; i++) {
                    subjects.push(res.data[i].subject);
                }
                this.setState({
                    subjects
                })
            });
    }

    handleChange(e, idx) {
        let data = this.state.data;
        data[idx][e.target.name] = e.target.value;
        if (e.target.name === "name") {
            data[idx][e.target.name] = e.target.value.toUpperCase();
            data[idx]['nameError'] = false;
        } else if (e.target.name === "classno") {
            data[idx]['classError'] = false;
        } else if (e.target.name === "subject") {
            data[idx]['subjectError'] = false;
        }
        this.setState({
            data
        })
    }

    handleOnAddBook(e) {
        e.preventDefault();
        let data = this.state.data;
        data.push({
            name: "",
            classno: 0,
            subject: ""
        })
        this.setState({
            data
        })
    }

    handleOnDeleteBook(e, idx) {
        e.preventDefault();
        let data = this.state.data;
        data.splice(idx, 1);
        this.setState({
            data
        })
    }

    validateData() {
        let error = false;
        let data = this.state.data;
        for (let i = 0; i < data.length; i++) {
            if (data[i].name === "") {
                data[i].nameError = true;
                error = true;
            }
            if (data[i].classno === 0) {
                data[i].classError = true;
                error = true;
            }
            if (data[i].subject === "") {
                data[i].subjectError = true;
                error = true;
            }
        }
        this.setState({
            data
        })
        return error;
    }

    handleSubmit() {
        let validationError = this.validateData();
        if (validationError) {
            swal('Error in Adding Books', 'Fill the required fields', 'error');
        } else {
            console.log('data', this.state.data);
            let data = this.state.data;
            axios.post(`${BASEURL}/api/v1/books/createBooks`, data)
                .then(res => {
                    if (res.status === 200) {
                        console.log('res.data', res.data);
                        swal("Success", "Books Added successfully", "success")
                            .then(function () {
                                window.location = "books";
                            })
                    } else {
                        console.log('res', res)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data)
                    swal('Error in Adding Books', err.response.data, 'error');
                    console.log('Create Books Error', err);
                })
        }
    }

    render() {
        return (
            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Add Books" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, 'Add New Books']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            {this.state.data.map((item, idx) => (
                                                <div className="row">
                                                    <div className="col-xl-3">
                                                        <div className="mb-3">
                                                            {idx === 0 ? <label htmlFor="bookname" className="form-label">Book Name</label> : ''}
                                                            <input type="text" id="bookname" className="form-control" onChange={(e) => this.handleChange(e, idx)}
                                                                name="name" placeholder="Enter Book Name"
                                                                value={item.name} />
                                                            {item.nameError ? <p className="errTxt">* required</p> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <div className="form-group mb-3">
                                                            {idx === 0 ? <label htmlFor="classNo" className="form-label">Class</label> : ''}
                                                            <select className="form-select"
                                                                onChange={(e) => this.handleChange(e, idx)}
                                                                name="classno" value={item.classno}>
                                                                <option value="0">Select class</option>
                                                                <option value="Nursery">Nursery</option>
                                                                <option value="LKG">LKG</option>
                                                                <option value="UKG"> UKG</option>
                                                                <option value="1">Class 1</option>
                                                                <option value="2">Class 2</option>
                                                                <option value="3">Class 3</option>
                                                                <option value="4">Class 4</option>
                                                                <option value="5">Class 5</option>
                                                                <option value="6">Class 6</option>
                                                                <option value="7">Class 7</option>
                                                                <option value="8">Class 8</option>
                                                                <option value="9">Class 9</option>
                                                                <option value="10">Class 10</option>
                                                                <option value="11">Class 11</option>
                                                                <option value="12">Class 12</option>
                                                            </select>
                                                            {item.classError ? <p className="errTxt">* required</p> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <div className="mb-3">
                                                            {idx === 0 ? <label htmlFor="subject" className="form-label">Subject</label> : ''}
                                                            <select className="form-select"
                                                                onChange={(e) => this.handleChange(e, idx)}
                                                                name="subject" value={item.subject}>
                                                                <option value="0">Select Subject</option>
                                                                {this.state.subjects.map((subject, idx) =>
                                                                    <option value={subject}>{subject}</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-3">
                                                        {idx === 0 ? <label htmlFor="actions" className="form-label">Actions</label> : ''}
                                                        <div className="mb-3">
                                                            <button className="btn btn-danger" onClick={(e) => this.handleOnDeleteBook(e, idx)}><i className="mdi mdi-minus-circle" /> Delete</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="mb-2">
                                                <button className="btn btn-success table_Action_btns" onClick={(e) => this.handleOnAddBook(e)}><i className="mdi mdi-plus-circle" /> Book</button>
                                            </div>
                                            <button type="submit" class="btn btn-customprimary" onClick={() => this.handleSubmit()}>Submit</button>
                                            {/* end row */}
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                </div> {/* end col*/}
                            </div>
                            {/* end row*/}
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>
            </div>
        )
    }
}

export default AddBooks;